export default "__VITE_ASSET__DTxrcKPs__"